import React from "react";
import { Flex } from '@chakra-ui/core'

export function PageContent({ children }) {
    return (
        <Flex minH="100vh" w="100vw" pt={["0px", "64px"]} bg="white" flexDirection="column">
            {children}  
        </Flex>  
    )
}
